export const isReactElement = (element) => {
    return element && typeof element === 'object' && 'props' in element;
};
